import React, { JSX, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Button, Card, Col, Form, Input, Row, Typography } from 'antd';
import axios from 'axios';
import '../components/ForgetPassword.scss'
import * as Yup from 'yup';
import { BackendAPI } from "../axios";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { yupResolver } from '@hookform/resolvers/yup';
import { Controller, set, useForm } from 'react-hook-form';
import { Spin } from "antd";
import { LoadingOutlined } from '@ant-design/icons';

const MySwal = withReactContent(Swal);


const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    // width: 400,
    pt: 2,
    px: 4,
    pb: 3,
    paddingRight: '8px',
};

interface forgetPasswordForm {
    username: string;
}

interface PageSettingsProps {
    setForgetModal: (value: boolean) => void;
}
function ForgetPassword({ setForgetModal }: PageSettingsProps): JSX.Element {
    // const [captchaText, setCaptchaText] = useState<string>('');
    const location = useLocation();
    const [captchaImage, setCaptchaImage] = useState('');
    const [captchaText, setCaptchaText] = useState('');
    const [loadings, setLoadings] = useState<boolean[]>(new Array(3).fill(false));
    const [isSeen, setIsSeen] = useState<boolean[]>(new Array(3).fill(false));
    // const dispatch = useDispatch();
    const validationSchema = Yup.object().shape({
        username: Yup.string().required('Email is required'),
    });

    const { control, watch, reset, handleSubmit, formState: { errors, touchedFields, isSubmitted } } = useForm({
        resolver: yupResolver(validationSchema),
        mode: 'onTouched',
    });

    const navigate = useNavigate();

    const [showLoginPassword, setShowLoginPassword] = useState(false);
    const [formData, setFormData] = useState({ username: '', });
    const [validationErrors, setValidationErrors] = useState({ username: '', password: '' });
    const [captchaError, setCaptchaError] = useState('');
    const [open, setOpen] = useState(false);
    const [otp, setOtp] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);

    const onSubmit = async (data: forgetPasswordForm) => {
        setLoading(true);
        try {
            const header = {
                headers: {
                    "Content-Type": "application/json",
                },
                params: {
                    email: `${data.username}`,
                },
            };
            const url = `/user/resetPassword`;
            const response = await BackendAPI.post(url, {}, header);
            if (response.data === "successtosendmail") {
                MySwal.fire({
                    icon: "success",
                    title: "📩 Check Your Email!",
                    text: "We've sent you a password reset link. Please check your inbox and click the 'Click Here' link to reset your password.",
                    confirmButtonColor: "#4CAF50",
                    confirmButtonText: "OK, Got It!",
                }).then(() => {
                    reset();
                    setForgetModal(false);
                });
            }
            if (response.data === "failtosendmail and return to forgot password page") {
                MySwal.fire({
                    icon: "error",
                    title: "Failed to send mail",
                    text: "Failed to send mail. Try again or contact to admin",
                    confirmButtonColor: "#4CAF50",
                    confirmButtonText: "OK, Got It!",
                }).then(() => {
                    reset();
                    setForgetModal(false);
                });
            }
            setForgetModal(false);
            setLoading(false);
        } catch (error) {
            // Handle network or other errors
            console.error('Error:', error);
            if (axios.isAxiosError(error))
                if (error.request.status === 401) {
                    MySwal.fire({
                        icon: 'error',
                        imageWidth: 100,
                        imageHeight: 100,
                        title: 'Email Not Registered',
                        text: 'We couldn’t find an account with that email. Please register first.',
                        confirmButtonColor: "#4CAF50",
                        confirmButtonText: "OK, Got It!",
                    }).then(() => {
                        reset();
                        setForgetModal(false);
                    });
                } else {
                    MySwal.fire({
                        icon: 'error',
                        imageWidth: 100,
                        imageHeight: 100,
                        title: 'Error',
                        text: 'Something went wrong',
                        confirmButtonColor: "#4CAF50",
                        confirmButtonText: "OK, Got It!",
                    }).then(() => {
                        reset();
                    });
                }
            setForgetModal(false);
            setLoading(false);
        }
    };
    //  Mail sending for forget Password End =========================================================

    const handleOpen = () => {
        reset();
        setForgetModal(false);
    };

    const handleClose = () => {
        setLoadings(new Array(3).fill(false));
        setIsSeen(new Array(3).fill(false));
        setOpen(false);
    };
    const labelStyle = {
        fontWeight: "bold",
        // padding: '0 10px',
        fontSize: '16px',
        // marginBottom: "8px", 
    };
    return (
        <>
            <ToastContainer
                position="top-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <div className="overlay">
                <div className="spinner-box">
                    <Spin spinning={loading} size='large'>

                        <Form className='login-form-modal' layout="vertical" onFinish={handleSubmit(onSubmit)} style={{ userSelect: 'none' }}>
                            <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                                {/* <UserOutlined style={{ padding: '10px', background: '#daecff', borderRadius: '30px', position: 'static', fontSize: '40px' }} /> */}
                                <h2 style={{ margin: '5px', }}>Forget Password</h2>
                                <p>Enter your email address and click the link sent to your inbox to reset your password.</p>
                            </div>
                            <Col xs={24} md={24}>
                                <Form.Item
                                    // label={<span style={labelStyle}>Username</span>}
                                    validateStatus={errors.username ? 'error' : ''}
                                    help={(touchedFields.username || isSubmitted) && errors.username ? errors.username.message : ''}
                                >
                                    <Controller
                                        name="username"
                                        control={control}
                                        render={({ field }) => <Input {...field} style={{ height: '40px' }} className="custom-placeholder" placeholder='Email Address' />}
                                    />
                                </Form.Item>
                            </Col>

                            <Button
                                type="primary" // Equivalent to MUI's color="primary" variant="contained"
                                className="sweep-to-blue-button"
                                htmlType="submit" // Equivalent to MUI's type="submit"
                                style={{ width: '100%' }} // Equivalent to MUI's fullWidth
                            >
                                Reset Password
                            </Button>
                        </Form>

                        <div style={{ display: 'flex' }}>
                            <Typography style={{ marginRight: 'auto', cursor: 'pointer' }}>
                                <Link to="/" onClick={handleOpen}>
                                    Back to Homepage
                                </Link>
                            </Typography>
                            <Typography style={{ cursor: 'pointer' }}>
                                <Link to="/registrationform" onClick={(e) => { setForgetModal(false); }}>
                                    Get Registered
                                </Link>
                            </Typography>
                        </div>

                    </Spin>
                </div>
            </div>
        </>
    );
}

export default ForgetPassword;

